/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_login_callback__success = /** @type {(inputs: {}) => string} */ () => {
	return `Sie wurden erfolgreich angemeldet`
};

const en_login_callback__success = /** @type {(inputs: {}) => string} */ () => {
	return `Login successful`
};

const es_login_callback__success = /** @type {(inputs: {}) => string} */ () => {
	return `Sesión iniciada con éxito`
};

const fr_login_callback__success = /** @type {(inputs: {}) => string} */ () => {
	return `Connexion réussie`
};

const it_login_callback__success = /** @type {(inputs: {}) => string} */ () => {
	return `Connessione riuscita`
};

const nl_login_callback__success = /** @type {(inputs: {}) => string} */ () => {
	return `Aanmelding geslaagd`
};

const pt_login_callback__success = /** @type {(inputs: {}) => string} */ () => {
	return `Fim de sessão bem-sucedido`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__success = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_callback__success(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_callback__success", locale)
	if (locale === "de") return de_login_callback__success(inputs)
	if (locale === "en") return en_login_callback__success(inputs)
	if (locale === "es") return es_login_callback__success(inputs)
	if (locale === "fr") return fr_login_callback__success(inputs)
	if (locale === "it") return it_login_callback__success(inputs)
	if (locale === "nl") return nl_login_callback__success(inputs)
	return pt_login_callback__success(inputs)
};